export default __webpack_public_path__ + "static/media/vector.b240993a.png";